// src/airportData.js

// 1) Import der Airports-Liste aus dem Paket
import { airports } from "@nwpr/airport-codes";  // :contentReference[oaicite:0]{index=0}

// 2) Override für deutsche IATA-Codes (mit korrekten Umlauten)
const DE_OVERRIDE = {
  FRA: "Frankfurt am Main",
  BER: "Berlin",
  MUC: "München",
  DUS: "Düsseldorf",
  CGN: "Köln/Bonn",
  HAM: "Hamburg",
  STR: "Stuttgart",
  NUE: "Nürnberg",
  LEJ: "Leipzig/Halle",
  HAJ: "Hannover",
  BRE: "Bremen",
  DTM: "Dortmund",
  FMO: "Münster/Osnabrück",
  FKB: "Karlsruhe/Baden-Baden",
  ERF: "Erfurt/Weimar",
  FDH: "Friedrichshafen",
  FMM: "Memmingen",
  HHN: "Frankfurt-Hahn",
  NRN: "Weeze",
  PAD: "Paderborn/Lippstadt",
  SCN: "Saarbrücken",
  RLG: "Rostock/Laage",
  SXF: "Schönefeld"
};

// 3) Automatisches Lookup aus dem Paket für alle anderen IATAs
const AUTO_MAP = airports.reduce((map, a) => {
  if (!a.iata) return map;
  // Nutze bevorzugt `city`, das Umlaute korrekt enthält
  map[a.iata] = a.city || a.name;
  return map;
}, {});

// 4) Liste nur deutscher IATAs fürs Abflug-Dropdown
export const GERMAN_IATAS = Object.keys(DE_OVERRIDE);

// 5) Zusammenführung für Ergebnis-Lookup
export const AIRPORTS = {
  ...AUTO_MAP,
  ...DE_OVERRIDE
};
